import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Circle } from 'react-google-maps';
import MapDetailsMarkerWrapper from './MapDetailsMarkerWrapper';


class MapDetailsWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoom: 13,
    };
  }

  onBoundsChanged = () => {
    this.setState({
      zoom: 15,
    });
  };


  render() {
    const { zoom } = this.state;
    const { lat, long, nearestLocations } = this.props.details;
    const centerLatLng = new window.google.maps.LatLng(parseFloat(lat), parseFloat(long));
    const bounds = new window.google.maps.LatLngBounds();

    bounds.extend(centerLatLng);

    nearestLocations.map((model) => {
      const { latitude, longitude } = model;
      const latLng = new window.google.maps.LatLng(latitude, longitude);

      bounds.extend(latLng);

      return latLng;
    });

    // hack when on e merker on the map
    // if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
    //   const extendPoint1 = new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.001,
    //     bounds.getNorthEast().lng() + 0.001);
    //   const extendPoint2 = new window.google.maps.LatLng(bounds.getNorthEast().lat() - 0.001,
    //     bounds.getNorthEast().lng() - 0.001);
    //
    //   bounds.extend(extendPoint1);
    //   bounds.extend(extendPoint2);
    // }

    const centerMarker = {
      strokeColor: '#0a4664',
      strokeOpacity: 0.3,
      strokeWeight: 2,
      fillColor: '#22739b',
      fillOpacity: 0.15,
    };

    return (
      <GoogleMap
        ref={map => map && (nearestLocations.length === 0 ? map.panToBounds(bounds) : null)}
        zoom={zoom}
        maxZoom={20}
        defaultOptions={{ mapTypeControl: false }}
        defaultCenter={{ lat, lng: long }}
        onBoundsChanged={this.onBoundsChanged}
      >
        <Circle radius={100} center={centerLatLng} options={centerMarker} />
        <MapDetailsMarkerWrapper markersArray={nearestLocations} />
      </GoogleMap>
    );
  }
}

MapDetailsWrapper.propTypes = {
  nearestLocations: PropTypes.arrayOf(PropTypes.shape),
  lat: PropTypes.number,
  long: PropTypes.number,
  details: PropTypes.shape([PropTypes.object]),

};

MapDetailsWrapper.defaultProps = {
  nearestLocations: [],
  lat: 0,
  long: 0,
  details: {},
};

export default MapDetailsWrapper;
